###
Gridspy Graph rendering code.

Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###

if not gs?
  window.gs = {}

months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']


gs.sum_columns = {
  min:
    desc: "Min"
  max:
    desc: "Max"
  kwh:
    desc: "Approx. kWh"
  accum:
    desc: "Accum"
  mean:
    desc: "Avg"
  price:
    desc: "Price"
}

gs.units = {
  PSI: {
    desc: "Air Pressure"
    axis: "Air Pressure (PSI)"
    weight: 60
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 1
  }
  litre: {
    desc: "Water Flow"
    axis: "Water Flow (litres/minute)"
    weight: 60
    incl_origin : false
    cols: ["min", "max", "mean", "accum"]
    rounding: 1
  }
  v_litre: {
    desc: "Measured Volume (l)"
    axis: "Flow Rate (litres/minute)"
    weight: 60
    incl_origin : false
    cols: ["min", "max", "mean", "accum"]
    rounding: 1
  }
  count: {
    desc: "Counts"
    axis: "Counter (counts/minute)"
    weight: 60
    incl_origin : false
    cols: ["min", "max", "mean", "accum"]
    rounding: 1
  }
  RH: {
    desc: "Relative Humidity"
    axis: "Relative Humidity (%)"
    weight: 60
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 1
  }
  watts: {
    desc: "Watts"
    axis: "Power (watts)"
    weight: 20
    incl_origin : true
    cols: ["min", "max", "mean", "kwh", "price"]
    rounding: 0
  }
  img: {
    desc: "Imaginary"
    axis: "Reactive power (imaginary watts)"
    weight: 20
    incl_origin : true
    cols: ["min", "max", "mean", "kwh", "price"]
    rounding: 1
  }
  PF : {
    desc: "Power Factor"
    axis: "Power Factor"
    weight: 10
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 2
  }
  amps: {
    desc: "Amperage"
    axis: "Current (amps)"
    weight: 30
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 2
  }
  volts: {
    desc: "Voltage"
    axis: "Voltage (volts)"
    weight: 50
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 1
  }
  temp: {
    desc: "Temperature"
    axis: "Temperature (Deg. C)"
    weight: 50
    incl_origin : false
    cols: ["min", "max", "mean"]
    rounding: 1
  }
}

gs.units['counts'] = gs.units['count']
gs.units['litres'] = gs.units['litre']
gs.units['deg C'] = gs.units['temp']

gs.get_unit = (unit_name) ->
  unit = gs.units[unit_name]
  return unit if unit?

  # Create a default unit:
  gs.units[unit_name] = {
    desc: unit_name
    axis: unit_name
    weight: 60
    incl_origin : true
    cols: ["min", "max", "mean"]
    rounding: 1
  }

  return gs.units[unit_name]

gs.time_intervals = [
    name:  'month'
    tag: '/month'
    freq:  120 * 60
    span: 30 * 24 * 60 * 60
    add:(date)->
      new Date(date).add(1).months()
    sub:(date)->
      new Date(date).add(-1).months()
    time_format: "d MMM yyyy"
  ,
    name:  'week'
    tag: '/week'
    freq:  30 * 60
    span: 7 * 24 * 60 * 60
    add:(date)->
      new Date(date).add(1).weeks()
    sub:(date)->
      new Date(date).add(-1).weeks()
    time_format: "d MMM yyyy"
  ,
    name:  'day'
    tag: '/day'
    freq:  5 * 60
    span: 1 * 24 * 60 * 60
    add:(date)->
      new Date(date).add(1).days()
    sub:(date)->
      new Date(date).add(-1).days()
    time_format: "HH:mm, d MMM"
  ,
    name:  '1/4 day'
    tag: '/quarter'
    freq:  1 * 60
    span: 6 * 60 * 60
    add:(date)->
      new Date(date).add(6).hours()
    sub:(date)->
      new Date(date).add(-6).hours()
    time_format: " HH:mm, d MMM"

  ,
    name:  'Live'
    tag: '/live'
    freq:  1
    span: 6 * 60
    add:(date)->
      new Date(date).add(5).minutes()
    sub:(date)->
      new Date(date).add(-5).minutes()
    time_format: "HH:mm:ss"
#  ,
#    name:  'hour'
#    tag: '/hour'
#    freq:  1
#    add:(date)->
#      new Date(date).add(1).hours()
#    sub:(date)->
#      new Date(date).add(-1).hours()
#    time_format: "d MMM yyyy HH:mm"
]

#============================ Graph widget ==================================
ko.bindingHandlers.gsCalendarPopup =
  init: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) ->
#    $(element).datepicker()
#
#    $(element).datepicker 'on', "changeDate", (ev) ->
#      #      if ev.date.valueOf() > endDate.valueOf()
#      #        $("#alert").show().find("strong").text "The start date can not be greater then the end date"
#      #      else
#      #        $("#alert").hide()
#      #        startDate = new Date(ev.date)
#      #        $("#startDate").text $("#dp4").data("date")
#      $(element).datepicker "hide"

    picker = $(element).datepicker({
        #    startDate: "10/05/2014",
        startView: 0,
        todayBtn: "linked",
        todayHighlight: true
        #    daysOfWeekDisabled: "6",
        autoclose: true
      })


    picker.on 'hide', (e)->
      args = ko.unwrap(valueAccessor())
      requestAnimFrame =>
        args['value'](e.date)

#    picker.on 'hide', (e)->
#      args = ko.unwrap(valueAccessor())
#      requestAnimFrame =>
#        args['value'](e.date)

    do ->
      args = ko.unwrap(valueAccessor())
      args['value'].subscribe (newVal) =>
        to_set = new Date(newVal).clearTime()
        $(element).datepicker('update', to_set)

#    $(element).on 'click', ->
#      args = ko.unwrap(valueAccessor())
#      $(element).datepicker('update', args['value']())

  update: (element, valueAccessor, allBindingsAccessor, viewModel) ->
#    args = ko.unwrap(valueAccessor())
#    date = args['value']()
#    $(element).datepicker("setDate", date)


#============================ Line Graphs ==================================
class ContextMgr
  # Holds all the contexts that are interesting right now.
  constructor: (@bindings) ->
    @all = ko.observableArray []
    @first_only = ko.observable true

    @time_intervals = gs.time_intervals
    @interval_idx = ko.observable 2

    @interval = ko.computed => @time_intervals[@interval_idx()]
    @big_interval = ko.computed => @time_intervals[Math.max(0, @interval_idx()-1)]
    @small_interval = ko.computed => @time_intervals[Math.min(3, @interval_idx()+1)]

    # Variables shared by all components on the screen
    @outer_start = ko.observable null
    @outer_end = ko.observable null

    window.setInterval (=>
      if @is_live()
        # Shift everything forwards to the present, preserving interval
        requestAnimFrame =>
          start_time = @start_time()
          interval = @end_time() - start_time
          now_time = new Date()

          if @auto_follow()
            time_30_sec = new Date(start_time).add(31).seconds()
            if time_30_sec > now_time
              @end_time time_30_sec
            else
              @end_time now_time

            if interval > 1000 * 120
              @start_time new Date().add(milliseconds: -interval)
          else if now_time < @end_time()
            # Refresh end time without changing it to
            @end_time @end_time()
    ), 1000

    @auto_follow = ko.observable false
    @start_time = ko.observable new Date().add(minutes:-1)
    @end_time = ko.observable new Date()
    @first_live = null

    # Timestamp of hover over graphs (for vertical rule and hovering data)
    @hover_time = ko.observable null

    # Pull times in from calendar time.
    #@bindings.calendar.selected_day.subscribe => @recalculate_times()
    @recalculate_times()
    @is_live = ko.computed => @interval().tag == '/live'

    @start = ko.computed
      write: (newVal) =>
        #@auto_follow false
        @start_time newVal
        #gs.bindings.update_url()

      read: =>
        time = @start_time()

        if @is_live() and @auto_follow() and @first_live > time
          @first_live
        else
          time

    @end = ko.computed
      write: (newVal) =>
        interval = newVal - @start_time()
        interval_secs = interval / 1000

        if @is_live()

          if newVal > new Date().add(interval_secs / 5).seconds()
            # Stop user scrolling more than 1/5 of screen beyond end of data.
            @end_time new Date()
            @start_time new Date().add(milliseconds: -interval)
            @auto_follow true
            return

          if @auto_follow()
#            if console?
#              console.log "Auto Follow turned off as new value for end time is #{newVal} whereas current time is #{new Date()}"
#              console.trace()
            @auto_follow false
        else
          @check_interval()

        @end_time newVal


      read: =>
        @end_time()

    @start_cal = ko.computed
      write: (newVal) =>
        # Adjust end time to equal new start time + selected interval
        @start_time newVal
        @end_time @interval().add(newVal)
      read: =>
        @start_time()

    @end_cal = ko.computed
      write: (newVal) =>
        # Check that the end time is still subsequent to the start time.

        @end_time newVal
        if newVal > @start_time()
          # Valid end time, so just check the interval...
          @check_interval()
        else
          # Need to move the start time to a point prior to this new end_time.
          @start_time @interval().sub(newVal)

      read: =>
        @end_time()

    @start_str = ko.computed =>
      format_str = @interval().time_format
      @start().toString(format_str)

    @end_str = ko.computed =>
      format_str = @interval().time_format
      @end().toString(format_str)

    @bindings.building.subscribe (newVal) =>
      if newVal?
        @first_live = null
        @set_time_interval(@interval_idx())

    # Store a primary context for the current location on the dash
    # Store secondary contexts (by position and elements created) for subcircuits

    # TODO: Start and end times displayed in string form above graphs
    # TODO: Update calendar widget to drive start and end times.

  get_building: () ->
    return gs.bindings.curr_building()

  check_interval :() ->
    interval = @end_time() - @start_time()
    interval_secs = interval / 1000

    if interval_secs > 0
      if @small_interval() != @interval() and @interval().span / 2 > interval_secs and @small_interval().span * 1.5 > interval_secs
        #drop to next lowest interval
        @interval_idx(@interval_idx() + 1)
      else if @big_interval() != @interval() and @interval().span * 2 < interval_secs and @big_interval().span / 1.5 < interval_secs
        # go to larger interval
        @interval_idx(@interval_idx() - 1)

  set_root_node : (root)->
    if root?
      tree_cursors = [new TreeContext(@, root)]
      tree_cursors[0].style "full"
      for node in root.children()
        tree_cursors.push new TreeContext(@, node)

      @all tree_cursors

  set_time_interval: (idx)=>
    # Find the interval in the list and then store that index
    @interval_idx idx
    if @is_live()
      @auto_follow true
      unless @first_live?
        gs.live_data?.connect_building @bindings.building()
        @first_live = new Date().add(seconds:-2)

      @end_time new Date()
      @start_time new Date().add(seconds:-10)

    else
      @recalculate_times()

  mod_dates: (mod_func) =>
    @start mod_func(@start())
    @end mod_func(@end())

  small_bk: => @mod_dates((time)=>@small_interval().sub(time))
  small_fw: => @mod_dates((time)=>@small_interval().add(time))

  large_bk: => @mod_dates((time)=>@interval().sub(time))
  large_fw: => @mod_dates((time)=>@interval().add(time))


  recalculate_times: ()=>
    end_time = @end_time()

    @outer_start @big_interval().sub(end_time)
    @outer_end new Date(end_time)

    @start_time @interval().sub(@outer_end())
    @end_time @outer_end()


class Context
  # Represents the details required to draw a graph
  constructor: (@mgr) ->
    @cursors = ko.observableArray []

    # Potential styles - collapsed, full
    @style = ko.observable "collapsed"
    @sensor_summary = ko.computed gs.common.defer => @calc_sensor_summary()
    @sensor_summary.extend
      throttle:500

    @freq = ko.computed => # Time Span in seconds

      if @mgr.is_live()
        return 1

      # time period in microseconds
      delta = @mgr.end() - @mgr.start()
      # convert to time period in minutes
      delta /= 1000 * 60

      return switch
        when delta < 60*7 then 1 * 60
        when delta < 1*60*25 then 5 * 60
        when delta < 4*60*24 then 15 * 60
        when delta < 8*60*24 then 60 * 60 # 1 week
        when delta < 34*60*24 then 120 * 60 # 1 month
        else 360 * 60

    @highlighted = ko.observable null
    @selected = ko.observableArray []
    @hidden = ko.observableArray []

    @include_origin = ko.observable true

    @type = 'base'
    @name = ko.observable "unnamed"

  is_hidden: (node) =>
    node in @hidden()

  toggle_show: (node) =>
    unless node in @hidden()
      @hidden.push(node)
      @unhighlight(node)
    else
      @hidden.remove(node)

  highlight: (node) =>
    @highlighted node

  unhighlight: (node) =>
    if @highlighted() == node
      @highlighted null


  set_root: () =>
    # does nothing

  calc_sensor_summary: ->

    t_min = t_max = null
    t_max_kwh = t_kwh = t_total = 0

#    p_sensor = @parent_sensor()
#    return null unless p_sensor?
#
#    unless gs.loading_mgr.loading()
#      overall_stats = gs.hist_stats p_sensor
#      {min: t_min, max: t_max, total: t_total, kwh:t_kwh} = overall_stats
#      t_kwh = parseFloat(t_kwh)
#    else
#      overall_stats = {min: null, max: null, total: null, kwh:null, percent:null, percent_max:null, price:null}
#
    overall_stats = {min: null, max: null, total: null, kwh:null, percent:null, percent_max:null, price:null}

    units_dict = {}
    building = @mgr.get_building()
    return unless building? # Something is very wrong if we don't have a building assigned to us.

    for cursor in @cursors()
      unit = units_dict[cursor.unit]
      unless unit?
        unit = units_dict[cursor.unit] = []

      measurement_unit = gs.get_unit(cursor.unit)
      col_types = measurement_unit.cols
      rounding = measurement_unit.rounding

      unless gs.loading_mgr.loading()
        [data_blocks, loaded] = cursor.get_data(@mgr.start(), @mgr.end(), @freq())
        stats = gs.calculate_statistics data_blocks, @mgr.start(), @mgr.end(), rounding, building.consts().price_kwh
        {min: min, max: max, total: total, kwh:s_kwh} = stats

        kwh = parseFloat(s_kwh)
        portion = kwh / t_kwh

        stats['percent'] = 100 * portion
        stats['percent_max'] = 100 * (kwh / t_max_kwh) # for bar length

        columns = for col in col_types
          if col == "price"
            "$#{stats[col]}"
          else
            stats[col]
      else
        stats = {min: null, max: null, total: null, kwh:null, percent:null, percent_max:null, price:null}

      unit.push
        sensor: cursor.node
        cursor: cursor
        columns: columns

    # Listify dict for KO
    units = for own unit, sensors of units_dict
      col_types = gs.get_unit(unit).cols

      col_headers = for col in col_types
        gs.sum_columns[col]

      col_headers: col_headers
      unit: gs.get_unit(unit)
      unit_name:  unit
      sensors: sensors

    return {units:units, overall: overall_stats}



class TreeContext extends Context
  # Represents the interesting children of a given TreeNode
  constructor: (mgr, @node) ->
    super mgr

    @type = 'tree'
    @name = @node.name

    @structured = gs.structured_units(@node)

    for {unit:unit, nodes:nodes} in @structured
      # This unit has traces "nodes" to display
      for node in nodes
        @cursors.push(new gs.DataCursor(node, unit))

  set_root: () =>
    path = @node.id
    gs.bindings.set_tree_pos path
    gs.bindings.update_url()
    return false
    #@mgr.set_root_node(@node)

graph_id = 0

class GraphBase
  constructor: (@element, @context, axis_height) ->
    # TODO: Graph loading indiciator when no useful data to show.
    #         Minor loading indicator when some data missing.

    @container = @element

    @data_param = []

    @g_repainting = false
    @g_updating = false
    @g_force_repaint = false

    @ready_data = null
    @ready_dirty = true
    @ready_sensors = null
    @ready_start = null
    @ready_end = null
    @ready_freq = null
    @ready_update_time = null

    @g_freq = null

    @id = graph_id += 1

    @wait_load = false

    num_axes = @context.structured.length
    if num_axes == 1
      axis_height *= 2

    @anim_left = false

  seperate_labels: () =>
    #Clone and sort lines by Y location
    sorted_lines = @data_param.slice(0)
    sorted_lines.sort((a,b)->a.hover_y_loc - b.hover_y_loc)

    collision = true
    spacing = 15
    iter = -1
    while collision
      collision = false
      iter += 1

      # Check for labels stuck to top of graph
      for idx in [0..sorted_lines.length-1]
        # Move all labels down off the top of the graph.
        if sorted_lines[idx].hover_y_loc < (spacing * (idx + 1)) - 1
          sorted_lines[idx].hover_y_loc = spacing * (idx + 1)
        else
          break

      # Check for labels stuck to bottom of graph
      for idx in [sorted_lines.length-1..0] by -1
        bottom_pos = @height - spacing * (sorted_lines.length - 1 - idx)
        if sorted_lines[idx].hover_y_loc > bottom_pos + 1
          sorted_lines[idx].hover_y_loc = bottom_pos
        else
          break

      for idx in [0..sorted_lines.length-1]
        continue if idx == 0
        if sorted_lines[idx - 1].hover_y_loc > sorted_lines[idx].hover_y_loc
          # A previous move has moved label at idx -1 below this label.
          collision = true
          sorted_lines[idx - 1].hover_y_loc -= spacing / 2 # move other label up
          sorted_lines[idx].hover_y_loc = sorted_lines[idx - 1].hover_y_loc + spacing + 1 # Move us back down.
        else
          distance = sorted_lines[idx].hover_y_loc - sorted_lines[idx - 1].hover_y_loc
          if distance < spacing
            collision = true
            under_spaced = spacing - distance + 2
            sorted_lines[idx-1].hover_y_loc -= under_spaced / 2
            sorted_lines[idx].hover_y_loc += under_spaced / 2

    return sorted_lines


  post_init: =>
    @queue_draw()
    @context.mgr.start.subscribe => @queue_draw()
    @context.mgr.end.subscribe => @queue_draw()
    @context.hidden.subscribe =>
      @queue_draw()
      @g_force_repaint = true

    gs.loading_mgr.loading.subscribe (newval) =>
      if newval == false
      # and @wait_load
        @queue_draw()

  get_start_end: =>
    start = @context.mgr.start();
    end = @context.mgr.end();
    return [start, end]

  get_graph_data: =>

    [start, end] = @get_start_end()
    @g_freq = @context.freq()

    unless @context.mgr.is_live()
      if not @wait_load and @ready_start? and @ready_data? and @ready_start < start and @ready_end > end and @ready_freq == @g_freq
        return false

#    if @ready_update_time? and @ready_update_time < new Date() and @ready_update_time > new Date().add(seconds:-1.9)
#      # Limit number of data updates.
#      @queue_draw()
#      return false

    # Expand start and end times to create a nice window in which we can scroll.
    start = new Date(start).add(-@g_freq * 60).seconds()
    end = new Date(end).add(@g_freq * 60).seconds()

    #console?.log "Refreshing data", start, end, freq

    complete = true
    data = []
    for cursor in @context.cursors()
      [c_data, c_complete] = cursor.get_data(start, end, @g_freq)
      data.push(c_data)
      complete &= c_complete

    if !complete
      @wait_load = true
      unless @ready_data?
        @ready_data = data
    else
      @wait_load = false
      @ready_start = start
      @ready_end = end
      @ready_freq = @g_freq
      @ready_update_time = new Date()
      @ready_data = data

    if not gs.loading_mgr.loading()
      return true
    else
      return complete

  update_data_param: =>
    # Sequence sensors
    @data_param = []

    highlighted = @context.highlighted()
    if highlighted == null or highlighted not in sensors
      highlighted = null

    hidden = @context.hidden()

    for own idx, cursor of @context.cursors()
      idx = parseInt(idx)
      sensor = cursor.node

      continue if cursor in hidden

      color = sensor.color()
      if highlighted == null
        shadow = 4
        line_width = 2
      else if highlighted == sensor
        shadow = 6
        line_width = 2
      else
        shadow = 1
        line_width = 1

      @data_param.push
        data: @ready_data[idx]
        unit: cursor.unit
        name: sensor.name()
        id: sensor.id
        color: color
        shadowSize: shadow
        line:
          lineWidth: line_width

  queue_draw: =>
    return if @g_repainting
    @g_repainting = true
    requestAnimFrame @do_queued_draw

  y_range: (data, include_origin, start, end, unit) =>
    min = max = null
    hidden = @context.hidden()

    for own sens_idx, sens_data of data
      cursor = @context.cursors()[sens_idx]
      continue if cursor in hidden

      s_unit = cursor.unit
      if unit? and s_unit != unit
        continue

      stats = gs.calculate_statistics(sens_data, start, end)

      {min:sensor_min, max:sensor_max} = stats
      sensor_min = parseFloat(sensor_min)
      sensor_max = parseFloat(sensor_max)
#      for store in sens_data
#        for data_idx, sample of store.data
#
#  #        if date < start
#  #          continue
#  #        if date > end
#  #          break
#          continue unless sample?
#
      if min?
        if sensor_min < min
          min = sensor_min
        if sensor_max > max
          max = sensor_max
      else
        min = sensor_min
        max = sensor_max

    range = max - min

    # Ensure that all graphs include 0 and expand the range just slightly.
    if include_origin and min > 0
      min = 0
    else
      min -= range * 0.05

    max += range * 0.05

#    unless min? and max? and not isNaN(min) and not isNaN(max) and min != max
#      console?.log "y_range: (",unit,") Invalid Min/Max (no data?) ", min, max

    return [min, max]

gs.ContextMgr = ContextMgr
gs.TreeContext = TreeContext
gs.GraphBase = GraphBase
